import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jiraBusinessCapacityCustomEmbedRoute } from '@atlassian/jira-router-routes-business-capacity-routes/src/jiraBusinessCapacityCustomEmbedRoute.tsx';
import { businessCapacityEntryPoint } from '@atlassian/jira-spa-apps-business-capacity/entrypoint.tsx';

export const jiraBusinessCapacityCustomEmbedRouteEntry = createEntry(
	jiraBusinessCapacityCustomEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.jwm-capacity-custom-embed',

		entryPoint: () => businessCapacityEntryPoint,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-business-capacity-entries/src/jiraBusinessCapacityCustomEmbedRouteEntry.tsx',
				whichExportToUse: 'jiraBusinessCapacityCustomEmbedRouteEntry',
			},

			enabled: true,
		},
	}),
);
